module.exports = __webpack_public_path__ + "static/media/companies.8e250a5e.png";